// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import { styled, keyframes } from "@mui/material/styles";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultReviewCard from "examples/Cards/ReviewCards/DefaultReviewCard";

// Images
import facebookLogo from "assets/images/logos/gray-logos/3.png";
import twitterLogo from "assets/images/logos/gray-logos/2.png";
import youtubeLogo from "assets/images/logos/gray-logos/4.png";
import linkedinLogo from "assets/images/logos/gray-logos/1.png";
import githubLogo from "assets/images/logos/gray-logos/5.png";

// Animation keyframes
const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

// Styled components
const LogoContainer = styled(Box)({
  overflow: "hidden",
  whiteSpace: "nowrap",
  width: "100%",
  background:
    "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 5%, rgba(255,255,255,1) 95%, rgba(255,255,255,0) 100%)",
});

const LogoWrapper = styled(Box)({
  display: "inline-block",
  animation: `${scroll} 40s linear infinite`,
  "&:hover": {
    animationPlayState: "paused",
  },
});

const Logo = styled("img")({
  width: "120px",
  height: "auto",
  margin: "0 30px",
  opacity: 0.6,
  display: "inline-block",
  verticalAlign: "middle",
  transition: "opacity 0.3s ease",
  "&:hover": {
    opacity: 1,
  },
});

// Component
function Information() {
  const logos = [twitterLogo, facebookLogo, youtubeLogo, linkedinLogo, githubLogo];

  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">Trusted by Over</MKTypography>
          <MKTypography variant="h2" color="info" textGradient mb={2}>
            555+ Local & Foreign Clients
          </MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
            Explore my References page, showcasing trusted tools, resources, and platforms that
            shaped my journey. Discover what fuels my creativity and professional growth.
          </MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 8 }}>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Daude Akduvaza"
              date="1 day ago"
              review="I had the pleasure of collaborating with CodeShow LapZ on a challenging project, and consistently impressed by their problem-solving skills. New technologies and learn quickly is a testament to their commitment to continuous improvement."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              color="info"
              name="Rayan Macklem"
              date="1 week ago"
              review="I highly recommend CodeShow LapZ for their expertise in web development. Their proficiency in languages like JavaScript, Python, and Node.js, along with their commitment to best practices, ensures that they consistently deliver top-notch results."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="James Willson"
              date="3 weeks ago"
              review="In addition to their technical skills, CodeShow LapZ is a pleasure to work with. Their positive attitude, willingness to collaborate, and problem-solving abilities make them a valuable asset to any organization."
              rating={5}
            />
          </Grid>
        </Grid>
        <Divider sx={{ my: 6 }} />
        <LogoContainer>
          <LogoWrapper>
            {logos.concat(logos, logos).map((logo, index) => (
              <Logo key={index} src={logo} alt={`Logo ${(index % logos.length) + 1}`} />
            ))}
          </LogoWrapper>
        </LogoContainer>
      </Container>
    </MKBox>
  );
}

export default Information;
